(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8201],{

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 8448:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotel-room-in-shimla/[slug]",
      function () {
        return __webpack_require__(5240);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const AccomodationSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Apartment",
                    "name": "The Twin Towers Hotel",
                    "description": "One of the best hotel in Kufri, it is located in the heart of town, amid the Himalayan foothills. The location is a beautiful retreat in a mountainous neighborhood, offering visitors a tranquil, calm, and pleasant atmosphere for a soul-filling holiday, and being so near to nature offers a choice of activities that will nourish your spirit. It will undoubtedly assist you in unwinding while you participate in the most exciting activities with your loved ones at and around the resort, since it is a great site for fun activities such as adventure sports, walks and trails, and so on.",
                    "numberOfRooms": 3,
                    "occupancy": {
                        "@type": "QuantitativeValue",
                        "minValue": 1,
                        "maxValue": 4
                    },
                    "floorLevel": 5,
                    "floorSize": {
                        "@type": "QuantitativeValue",
                        "value": 81,
                        "unitCode": "MTK"
                    },
                    "numberOfBathroomsTotal": 2,
                    "numberOfBedrooms": 2,
                    "petsAllowed": true,
                    "tourBookingPage": "",
                    "yearBuilt": 2014,
                    "telephone": "+91 07807885113",
                    "address": {
                        "@type": "PostalAddress",
                        "addressCountry": "IN",
                        "addressLocality": "NH 05, New kufri, Galu, Hills",
                        "addressRegion": "Indian Himalayan Region",
                        "postalCode": "171209",
                        "streetAddress": "NH 05, New kufri, Galu, Hills"
                    },
                    "latitude": 31.100830,
                    "longitude": 77.264710
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (AccomodationSchema);


/***/ }),

/***/ 9881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const BreadCrumbSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    "itemListElement": [
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "About Us",
                            "item": "https://www.hoteltwintowers.com/about-us"
                        },
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": "Room and Suits",
                            "item": "https://www.hoteltwintowers.com/hotel-room-in-shimla"
                        },
                        {
                            "@type": "ListItem",
                            "position": 3,
                            "name": "Bar and Restaurant",
                            "item": "https://www.hoteltwintowers.com/bar-and-restaurant"
                        },
                        {
                            "@type": "ListItem",
                            "position": 4,
                            "name": "Events",
                            "item": "https://www.hoteltwintowers.com/#events"
                        },
                        {
                            "@type": "ListItem",
                            "position": 5,
                            "name": "Banquet Halls in Shimla",
                            "item": "https://www.hoteltwintowers.com/banquet-halls-in-shimla"
                        },
                        {
                            "@type": "ListItem",
                            "position": 6,
                            "name": "Conference Halls",
                            "item": "https://www.hoteltwintowers.com/conference-hall"
                        }
                    ]
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbSchema);


/***/ }),

/***/ 1058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const HotelSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "http://schema.org",
                    "@type": "Hotel",
                    "name": "The Twin Towers Hotel",
                    "alternateName": "If Known by Another Shorter Name",
                    "url": "https://hoteltwintowers.com/",
                    "logo": "https://www.hoteltwintowers.com/icons/header-logo.svg",
                    "image": "https://www.hoteltwintowers.com/images/home-banner.png",
                    "description": "One of the best hotel in Kufri, it is located in the heart of town, amid the Himalayan foothills. The location is a beautiful retreat in a mountainous neighborhood, offering visitors a tranquil, calm, and pleasant atmosphere for a soul-filling holiday, and being so near to nature offers a choice of activities that will nourish your spirit. It will undoubtedly assist you in unwinding while you participate in the most exciting activities with your loved ones at and around the resort, since it is a great site for fun activities such as adventure sports, walks and trails, and so on.",
                    "sameAs": [
                        "https://www.facebook.com/twintower.hotel/",
                        "https://www.instagram.com/hotel_twintowers/",
                        "https://www.linkedin.com/in/the-twin-towers-hotel/"
                    ],
                    "telephone": "+91 07807885113",
                    "email": "info@hoteltwintowers.com",
                    "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                    "checkinTime": "14:00",
                    "checkoutTime": "12:00",
                    "additionalType": "",
                    "areaServed": "",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "NH 05, New kufri,",
                        "addressLocality": "Galu, Hills,",
                        "addressRegion": "Shimla",
                        "postalCode": "171209",
                        "addressCountry": "India"
                    },
                    "priceRange": "$$$",
                    "starRating": {
                        "@type": "http://schema.org/Rating",
                        "ratingValue": "5"
                    }
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (HotelSchema);


/***/ }),

/***/ 8360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const LocalBusinessSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "LocalBusiness",
                    "name": "The Twin Towers Hotel",
                    "image": "https://www.hoteltwintowers.com/images/home-banner.png",
                    "@id": "",
                    "url": "https://hoteltwintowers.com/",
                    "telephone": "+91 07807885113",
                    "priceRange": "$$$",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "NH 05, New kufri, Galu, Hills",
                        "addressLocality": "Shimla",
                        "postalCode": "171209",
                        "addressCountry": "IN"
                    },
                    "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 31.0891785,
                        "longitude": 77.28672519999999
                    },
                    "sameAs": [
                        "https://www.facebook.com/twintower.hotel/",
                        "https://www.instagram.com/hotel_twintowers/",
                        "https://www.linkedin.com/in/the-twin-towers-hotel/"
                    ]
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (LocalBusinessSchema);


/***/ }),

/***/ 6601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const LodgingReservationSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "http://schema.org",
                    "@type": "LodgingReservation",
                    "reservationNumber": "",
                    "reservationStatus": "http://schema.org/Confirmed",
                    "underName": {
                        "@type": "Person",
                        "name": "John Smith"
                    },
                    "reservationFor": {
                        "@type": "LodgingBusiness",
                        "name": "The Twin Towers Hotel",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "NH 05, New kufri, Galu, Hills",
                            "addressLocality": "Shimla",
                            "addressRegion": "Indian Himalayan Region",
                            "postalCode": "171209",
                            "addressCountry": "IN"
                        },
                        "telephone": "07807885113"
                    },
                    "checkinDate": "",
                    "checkoutDate": ""
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (LodgingReservationSchema);


/***/ }),

/***/ 5154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const RestaurantSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "http://schema.org",
                    "@type": "Restaurant",
                    "servesCuisine": [
                        "Italian",
                        "Indian",
                        "Chinese"
                    ],
                    "logo": "https://www.hoteltwintowers.com/icons/header-logo.svg",
                    "image": "https://www.hoteltwintowers.com/images/restaurant-banner.png",
                    "priceRange": "",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "NH 05, New kufri, Galu, Hills,",
                        "addressLocality": "Shimla",
                        "addressRegion": "Indian Himalayan Region",
                        "postalCode": "171209",
                        "addressCountry": "India"
                    },
                    "name": "The Twin Towers Hotel",
                    "telephone": "+91 07807885113",
                    "email": "info@hoteltwintowers.com",
                    "url": "https://www.hoteltwintowers.com/bar-and-restaurant",
                    "hasMenu": "",
                    "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                    "containedInPlace": {
                        "@type": "Place",
                        "name": "The Twin Towers Hotel",
                        "url": "https://www.hoteltwintowers.com",
                        "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5"
                    }
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (RestaurantSchema);


/***/ }),

/***/ 6240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Topbanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9262);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Topbanner(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container common_title text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: props.title
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 5240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Room; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(9755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./src/styles/pages/Rooms.module.scss
var Rooms_module = __webpack_require__(731);
var Rooms_module_default = /*#__PURE__*/__webpack_require__.n(Rooms_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Topbanner/Topbanner.js
var Topbanner = __webpack_require__(6240);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/Schema/HotelSchema/organisation.js


/* harmony default export */ var organisation = (()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "The Twin Towers Hotel",
                    "url": "https://hoteltwintowers.com/",
                    "logo": "https://www.hoteltwintowers.com/icons/header-logo.svg",
                    "sameAs": [
                        "https://www.facebook.com/twintower.hotel/",
                        "https://www.instagram.com/hotel_twintowers/",
                        "https://www.linkedin.com/in/the-twin-towers-hotel/"
                    ]
                })
            }
        })
    }));

// EXTERNAL MODULE: ./src/components/Schema/HotelSchema/accomodation.js
var accomodation = __webpack_require__(7782);
// EXTERNAL MODULE: ./src/components/Schema/HotelSchema/breadcrumb.js
var breadcrumb = __webpack_require__(9881);
// EXTERNAL MODULE: ./src/components/Schema/HotelSchema/local-business.js
var local_business = __webpack_require__(8360);
// EXTERNAL MODULE: ./src/components/Schema/HotelSchema/hotel-schema.js
var hotel_schema = __webpack_require__(1058);
// EXTERNAL MODULE: ./src/components/Schema/HotelSchema/lodgingreservation.js
var lodgingreservation = __webpack_require__(6601);
// EXTERNAL MODULE: ./src/components/Schema/HotelSchema/restaurant-schema.js
var restaurant_schema = __webpack_require__(5154);
;// CONCATENATED MODULE: ./src/components/Schema/HotelSchema/deluxe-room-schema.js


/* harmony default export */ var deluxe_room_schema = (()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "http://schema.org",
                    "@type": "HotelRoom",
                    "name": "Deluxe Rooms",
                    "url": "https://www.hoteltwintowers.com/hotel-room-in-shimla/deluxe-room",
                    "image": "https://www.hoteltwintowers.com/images/deluxe-banner.png",
                    "description": "These spacious rooms (380 square feet) are equipped with all the latest conveniences and amenities for a relaxing and luxurious stay. These are one of the best deluxe rooms in Kufri. There is high-speed Internet access (Wi-Fi), an LED TV, an electric kettle, an ironing board, a wardrobe, a daily cleaning service, a hair dryer, and more in each room.",
                    "containedInPlace": {
                        "@type": "Place",
                        "name": "The Twin Towers Hotel",
                        "url": "https://hoteltwintowers.com/",
                        "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "NH 05, New kufri, Galu, Hills,",
                            "addressLocality": "Shimla",
                            "addressRegion": "Indian Himalayan Region",
                            "postalCode": "171209",
                            "addressCountry": "India"
                        }
                    },
                    "bed": {
                        "@type": "BedDetails",
                        "numberOfBeds": 2
                    },
                    "occupancy": {
                        "@type": "QuantitativeValue",
                        "maxValue": "2"
                    },
                    "amenityFeature": [
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "City Views"
                        },
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "Balcony"
                        },
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "King Size Bed"
                        }
                    ]
                })
            }
        })
    }));

;// CONCATENATED MODULE: ./src/components/Schema/HotelSchema/executive-room-schema.js


/* harmony default export */ var executive_room_schema = (()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "http://schema.org",
                    "@type": "HotelRoom",
                    "name": "Executive Room",
                    "url": "https://www.hoteltwintowers.com/hotel-room-in-shimla/executive-room",
                    "image": "https://www.hoteltwintowers.com/images/exec-banner.png",
                    "description": "These 80-square-meter rooms provide highly customized attention and maximum convenience. These best executive rooms in Kufri are fully soundproof and include contemporary furnishings. Guests may enjoy modern conveniences including a keyless entry system, free Wi-Fi, a smart TV, a tea and coffee maker, and more.",
                    "containedInPlace": {
                        "@type": "Place",
                        "name": "The Twin Towers Hotel",
                        "url": "https://hoteltwintowers.com/",
                        "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "NH 05, New kufri, Galu, Hills,",
                            "addressLocality": "Shimla",
                            "addressRegion": "Indian Himalayan Region",
                            "postalCode": "171209",
                            "addressCountry": "India"
                        }
                    },
                    "bed": {
                        "@type": "BedDetails",
                        "numberOfBeds": 2
                    },
                    "occupancy": {
                        "@type": "QuantitativeValue",
                        "maxValue": "2"
                    },
                    "amenityFeature": [
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "City Views"
                        },
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "Balcony"
                        },
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "King Size Bed"
                        }
                    ]
                })
            }
        })
    }));

;// CONCATENATED MODULE: ./src/components/Schema/HotelSchema/family-room-schema.js


/* harmony default export */ var family_room_schema = (()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "http://schema.org",
                    "@type": "HotelRoom",
                    "name": "Family Suite",
                    "url": "https://www.hoteltwintowers.com/hotel-room-in-shimla/family-suite-room",
                    "image": "https://www.hoteltwintowers.com/images/family-banner.png",
                    "description": "Our 650-square-feet Family Suite has a classic design and a picturesque view of the mountains. All the amenities you might want are there, from a walk-in wardrobe to king-sized beds to a minibar to an electric safe to Wi-Fi to LED televisions to contemporary bathrooms with luxurious toiletries to electronic key entrance and more. The special amenities in this room category are here to make your stay more enjoyable and productive making it the best family suite in Kufri.",
                    "containedInPlace": {
                        "@type": "Place",
                        "name": "The Twin Towers Hotel",
                        "url": "https://hoteltwintowers.com/",
                        "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "NH 05, New kufri, Galu, Hills,",
                            "addressLocality": "Shimla",
                            "addressRegion": "Indian Himalayan Region",
                            "postalCode": "171209",
                            "addressCountry": "India"
                        }
                    },
                    "bed": {
                        "@type": "BedDetails",
                        "numberOfBeds": 2
                    },
                    "occupancy": {
                        "@type": "QuantitativeValue",
                        "maxValue": "2"
                    },
                    "amenityFeature": [
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "City Views"
                        },
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "Balcony"
                        },
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "King Size Bed"
                        }
                    ]
                })
            }
        })
    }));

;// CONCATENATED MODULE: ./src/components/Schema/HotelSchema/premier-room-schema.js


/* harmony default export */ var premier_room_schema = (()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "http://schema.org",
                    "@type": "HotelRoom",
                    "name": "Premier Room",
                    "url": "https://www.hoteltwintowers.com/hotel-room-in-shimla/premier-room",
                    "image": "https://www.hoteltwintowers.com/images/premier-banner.png",
                    "description": "These best premier rooms in Kufri are spacious measuring in at 380 square feet. They come with a king-sized bed and breath-taking views of the surrounding valley. This room has a desk with an elegant design, an electric safe, free Wi-Fi, a sitting area, a hardwood floor, a closet, and other storage space.",
                    "containedInPlace": {
                        "@type": "Place",
                        "name": "The Twin Towers Hotel",
                        "url": "https://www.hoteltwintowers.com/",
                        "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "NH 05, New kufri, Galu, Hills,",
                            "addressLocality": "Shimla",
                            "addressRegion": "Indian Himalayan Region",
                            "postalCode": "171209",
                            "addressCountry": "India"
                        }
                    },
                    "bed": {
                        "@type": "BedDetails",
                        "numberOfBeds": 2
                    },
                    "occupancy": {
                        "@type": "QuantitativeValue",
                        "maxValue": "2"
                    },
                    "amenityFeature": [
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "City Views"
                        },
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "Balcony"
                        },
                        {
                            "@type": "LocationFeatureSpecification",
                            "value": "True",
                            "name": "King Size Bed"
                        }
                    ]
                })
            }
        })
    }));

;// CONCATENATED MODULE: ./src/components/Schema/index.js














/* harmony default export */ var Schema = ((param)=>{
    let { name  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            name === "Organistion" && /*#__PURE__*/ (0,jsx_runtime.jsx)(organisation, {}),
            name === "Accomodation" && /*#__PURE__*/ (0,jsx_runtime.jsx)(accomodation/* default */.Z, {}),
            name === "Breadcrumb" && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {}),
            name === "LocalBusiness" && /*#__PURE__*/ (0,jsx_runtime.jsx)(local_business/* default */.Z, {}),
            name === "HotelSchema" && /*#__PURE__*/ (0,jsx_runtime.jsx)(hotel_schema/* default */.Z, {}),
            name === "LodgingReservation" && /*#__PURE__*/ (0,jsx_runtime.jsx)(lodgingreservation/* default */.Z, {}),
            name === "RestaurantSchema" && /*#__PURE__*/ (0,jsx_runtime.jsx)(restaurant_schema/* default */.Z, {}),
            name === "DeluxeRoomSchema" && /*#__PURE__*/ (0,jsx_runtime.jsx)(deluxe_room_schema, {}),
            name === "ExecutiveRoomSchema" && /*#__PURE__*/ (0,jsx_runtime.jsx)(executive_room_schema, {}),
            name === "FamilyRoomSchema" && /*#__PURE__*/ (0,jsx_runtime.jsx)(family_room_schema, {}),
            name === "PremierRoomSchema" && /*#__PURE__*/ (0,jsx_runtime.jsx)(premier_room_schema, {})
        ]
    });
});

// EXTERNAL MODULE: ./src/components/BestDeal/BookNowButton.js
var BookNowButton = __webpack_require__(8380);
;// CONCATENATED MODULE: ./src/pages/hotel-room-in-shimla/[slug].js










var __N_SSG = true;
function Room(param) {
    let { room , allRooms  } = param;
    const [filteredRoom, setFilteredroom] = (0,react.useState)(allRooms);
    let filteredArray = filteredRoom.filter((item)=>item.slug !== room.slug);
    const otherRooms = filteredArray;
    const roomamenities = room.amenities;
    const galleryImg = room.gallery;
    const gallery_slider = {
        dots: false,
        infinite: false,
        arrows: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Schema, {
                name: room.SingleRoomSchema
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: room.metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: room.metaDesc
                    }, "desc"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.hoteltwintowers.com/hotel-room-in-shimla/".concat(room === null || room === void 0 ? void 0 : room.slug)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Topbanner/* default */.Z, {
                bgImage: room.banner,
                title: room.roomName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((Rooms_module_default()).single_blog, " common_padding"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "common_title text-center pb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Description"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: room.roomDesc
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Rooms_module_default()).gallery_main,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib["default"], {
                                ...gallery_slider,
                                className: "single_room_slider",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Rooms_module_default()).gallery_child,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: galleryImg.imageone,
                                            alt: "Single Room Image"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Rooms_module_default()).gallery_child,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: galleryImg.imagetwo,
                                            alt: "Single Room Image"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Rooms_module_default()).gallery_child,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: galleryImg.imagethree,
                                            alt: "Single Room Image"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Rooms_module_default()).gallery_child,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: galleryImg.imageone,
                                            alt: "Single Room Image"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Rooms_module_default()).gallery_child,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: galleryImg.imagefive,
                                            alt: "Single Room Image"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((Rooms_module_default()).booking_cont, " row justify-content-center common_title"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((Rooms_module_default()).booking_col, " col-lg-4 col-md-8 col-sm-8"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: "Grab The Best Deal"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((Rooms_module_default()).button_col, " col-lg-2 col-md-4 col-sm-4"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookNowButton/* default */.Z, {
                                        style: {
                                            width: "100%",
                                            height: "100%",
                                            margin: "0"
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((Rooms_module_default()).amenities_main, " row justify-content-center"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-8 py-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row common_title text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: "Room Amenities"
                                        }),
                                        roomamenities.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((Rooms_module_default()).amenities_child, " col-md-4 col-sm-6 pt-4"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: item.icon,
                                                        width: 45,
                                                        height: 38,
                                                        className: (Rooms_module_default()),
                                                        alt: "Amenities icon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: item.title
                                                    })
                                                ]
                                            }, index))
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((Rooms_module_default()).similar_rooms, " "),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row common_title",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-center",
                                        children: "Similar Rooms"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib["default"], {
                                        ...settings,
                                        className: "activity_slider similar_room_slide",
                                        children: otherRooms.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                    href: "/hotel-room-in-shimla/".concat(item.slug),
                                                    className: (Rooms_module_default()).similar_room_child,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((Rooms_module_default()).bg_image, " m-0"),
                                                            style: {
                                                                backgroundImage: "url(".concat(item.roomsImage, ")")
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((Rooms_module_default()).similer_inner_text, " common_title m-0"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    children: item.roomName
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: item.shortDesc
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (Rooms_module_default()).rooms_center_amen,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: "/icons/bed.svg",
                                                                            alt: "bed icon"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: "/icons/guests.svg",
                                                                            alt: "guests icon"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: "/icons/coffee.svg",
                                                                            alt: "coffee icon"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, index))
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 9262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__iVW4z","banner_text":"Topbanner_banner_text__wm4dg"};

/***/ }),

/***/ 731:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rooms":"Rooms_rooms__NlERG","rooms_main":"Rooms_rooms_main__HdrVW","rooms_left":"Rooms_rooms_left__jIfOA","rooms_right":"Rooms_rooms_right__ZwXWC","rooms_center":"Rooms_rooms_center__N80h9","rooms_center_amen":"Rooms_rooms_center_amen__qKl6E","right_amen":"Rooms_right_amen__LGwZN","rooms_center_desc":"Rooms_rooms_center_desc__fU4ll","single_blog":"Rooms_single_blog__xXf7q","gallery_main":"Rooms_gallery_main__ov7_C","gallery_child":"Rooms_gallery_child__IAOAc","booking_cont":"Rooms_booking_cont__d7mEW","booking_col":"Rooms_booking_col__SSMlh","button_col":"Rooms_button_col__P3pMY","check_now_btn":"Rooms_check_now_btn__Exk75","amenities_main":"Rooms_amenities_main__qdnqd","amenities_child":"Rooms_amenities_child__BWEL5","similar_rooms":"Rooms_similar_rooms__WyJ6m","similar_room_child":"Rooms_similar_room_child__XdoqR","bg_image":"Rooms_bg_image__59AXv","similer_inner_text":"Rooms_similer_inner_text__3NYBn","delux_icone":"Rooms_delux_icone__pq_fe"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9774,2888,179], function() { return __webpack_exec__(8448); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);